module.exports = __webpack_public_path__ + "img/computer.5751a057.png";